<template lang="pug">
  .email-capture-form
    form(@submit.prevent="submitEmail")
      MrEmailInput.mt-10.mb-10(
        v-model="email"
        :valid.sync="validEmail"
        :disabled="loading"
      )
        .loading(v-if="loading")
          img(:src="'/images/ajax-loader.gif'")
        button.mr-btn.inner-submit-button(
          v-else
          :class="{ disabled: !validEmail }"
          type="submit"
          data-mr-ass="email-submit-button"
          :disabled="!validEmail"
        )
          i.icon-caret-right

    .captcha(v-if="showCaptcha")
      Captcha(@captcha-response="onCaptchaResponse")

    p.email-in-use-message.feedback-color-1.xs-f-xsmall.sm-f-xxsmall.max-at-tweak.mb-10(v-if="emailInUse") 
      | Email already subscribed. Try a different email.
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import { EMAIL_CAPTURE_DEFAULT_CONFIG } from '../constants'; 
  import { getObjProperty } from '@utilities/mrVueUtils';
  import { createCustomerFromEmailCapture } from '@services/vueCustomerSvc';
  import MrEmailInput from '@components/MrEmailInput';
  import Captcha from '@components/captcha';

  const defaultPromoCode = EMAIL_CAPTURE_DEFAULT_CONFIG.code;
  const defaultEmailSource = EMAIL_CAPTURE_DEFAULT_CONFIG.email_source;

  const EMAIL_CAPTURE_HCB_EXPERIMENT = 'email capture hcb experiment';

  export default {
    name: 'EmailCaptureForm',

    components: {
      MrEmailInput,
      Captcha,
    },

    inject: ['getObjProperty'],

    props: {
      type: {
        type: String,
        required: true,
      },

      code: {
        type: String,
        default: defaultPromoCode,
      },

      emailSource: {
        type: String,
        default: defaultEmailSource,
      },
    },

    data: () => ({
      email: null,
      captchaResponse: null,
      loading: false,
      validEmail: false,
      showCaptcha: false,
      emailInUse: false,
    }),

    computed: {
      ...mapGetters('emailCapture', [
        'subscribed',
      ]),
    },

    methods: {
      ...mapActions(['notifyError']),
      ...mapActions('emailCapture', [
        'trackEvent', 
      ]),

      ...mapMutations('emailCapture', [
        'setSubscribed',
      ]),

      ...mapActions('customer', [
        'refreshCustomerCdata',
      ]),

      onCaptchaResponse(response) {
        this.captchaResponse = response;
        this.submitEmail();
      },

      submitEmail() {
        if (!this.validEmail) {
          return;
        }

        this.loading = true;
        this.emailInUse = false;
        this.showCaptcha = false;
        this.createCustomerWithPromo().then((response) => {
          const offerApplied = !!this.getObjProperty(response, 'data.offerApplied');
          
          this.loading = false;

          if (!offerApplied) {
            this.emailInUse = true;
            return;
          }

          this.setSubscribed(true);

          let variation;
          if (window.location.pathname.indexOf('/colorbar') === 0) {
            variation = window.experiments[EMAIL_CAPTURE_HCB_EXPERIMENT];
          }

          if (this.type === 'modal') {
            this.trackEvent('emailCaptureModalSubmit', {
              variation,
            });
          } else {
            this.trackEvent('emailCaptureFooterSubmit');
          }
          this.refreshCustomerCdata();
        }).catch((err) => {
          this.loading = false;
          const code = getObjProperty(err, 'response.data.code');
          
          if (code === 'USER_ALREADY_EXISTS') {
            this.emailInUse = true;
            return;
          }

          if (code === 'CAPTCHA') {
            this.showCaptcha = true;
            return;
          }

          this.notifyError({ err });
        });
      },

      createCustomerWithPromo() {
        return createCustomerFromEmailCapture({
          offerCode: this.code,
          isBookingOfferCode: this.code !== defaultPromoCode,
          captchaResponse: this.captchaResponse,
          email: this.email,
          email_source: this.emailSource,
          skipPassword: true,
        });
      },
    },
  };
</script>

<style lang="stylus">
  .email-capture-form
    overflow hidden
    button
      padding 4px
      width 100%
      height 100%
      border-radius 4px
    .loading
      padding 4px
      width 100%
      height 100%
      vertical-align center
      display flex
      align-items center
      justify-content center
      img
        width 20px
        height 20px
</style>
